module.exports = __webpack_public_path__ + "img/05.efcf1313.png";